import { MDSIcon, MDSIconColor } from "@/mds/components/icon";
import { StyledBadge, StyledLabel } from "./badge.style";
import { IMDSBadgeProps, MDSBadgeVariant } from "./badge.types";

export const MDSBadge = ({
  icon,
  label,
  variant = MDSBadgeVariant.Default,
  className,
  id,
}: IMDSBadgeProps) => {
  return (
    <StyledBadge className={className} id={id} data-mds-name="badge" $variant={variant}>
      {icon && <MDSIcon boxSize={12} size={9} kind={icon} color={MDSIconColor.Inherit} />}
      <StyledLabel>{label}</StyledLabel>
    </StyledBadge>
  );
};
